import { useCallback, useContext, useEffect, useState } from "react";
import { FaCog, FaHome, FaSun, FaTable } from "react-icons/fa";
import Pager from "components/ui/controls/pager/pager";
import { AppContext } from "components/app/RemExprertProvider";
import DossierPage from "pages/audit complet/dossier/dossier";
import RetraitePage from "pages/audit complet/retraite/retraite";
import ResultatPageRetraite from "./resultat/resultatRetraite";
import RachatTrimestrePage from "./resultat/rachatTrimestre";
import RetraiteProgressivePage from "./resultat/retraiteProgressive";
import { RemExpertResultatTNS } from "components/app/Api/ResultatRemExpertTNSProvider";
import { RemoveUnecessaryData } from "components/app/Api/ApiData";
import SimulationRetraite from "./resultat/simulationRetraite";
import CarrierePage from "./carriere";
import StudyManagement from "components/ui/layout/StudyManagement";
import Dialogs from "components/ui/dialogs/dialogs";
import { useStudyManagementHandlers } from "../studyManagementHandler";

const AuditRetraitePage = (props) => {
  const context = useContext(AppContext);
  const ResultatTNS = useContext(RemExpertResultatTNS);
  const [currentPage, setCurrentPage] = useState(1);
  
  // Utilisation du hook personnalisé pour la gestion de l'étude
  const { handleSave, handleGoToAudits, handleGoToExtranet } = useStudyManagementHandlers(props);

  const sendToIframe = useCallback(
    ({ data }) => {
      if (data === "save") {
        let CleanData = RemoveUnecessaryData(context.state);
        delete CleanData.IdUser;
        delete CleanData.IdCabinet;
        let Resultat = {
          RetraiteBrute:
            ResultatTNS.state.Retraite?.InfosRetraiteChoixDepart?.TotalPensionRenteBrute === undefined ? 0 : ResultatTNS.state.Retraite?.InfosRetraiteChoixDepart?.TotalPensionRenteBrute,
          RetraiteNette:
            ResultatTNS.state.Retraite?.InfosRetraiteChoixDepart?.TotalRetraiteNetteChoixDepartRetraite === undefined
              ? 0
              : ResultatTNS.state.Retraite?.InfosRetraiteChoixDepart?.TotalPensionRenteBrute,
          RetraiteBruteConjoint:
            ResultatTNS.state.RetraiteConjoint?.InfosRetraiteChoixDepart?.TotalPensionRenteBrute === undefined
              ? 0
              : ResultatTNS.state.RetraiteConjoint?.InfosRetraiteChoixDepart?.TotalPensionRenteBrute,
          RetraiteNetteConjoint:
            ResultatTNS.state.RetraiteConjoint?.InfosRetraiteChoixDepart?.TotalRetraiteNetteChoixDepartRetraite === undefined
              ? 0
              : ResultatTNS.state.RetraiteConjoint?.InfosRetraiteChoixDepart?.TotalPensionRenteBrute,
        };
        let evt = {
          Action: "save",
          DonneesMako: JSON.stringify(CleanData),
          Resultat: Resultat,
        };
        window.top.postMessage(evt, "*");
      }
    },
    [context.state, ResultatTNS.state]
  );



  useEffect(() => {
    window.addEventListener("message", sendToIframe);
    return () => window.removeEventListener("message", sendToIframe);
  }, [sendToIframe]);

  const handlePages = () => {
    let pages = [];
    pages = [
      {
        isTitle: true,
        title: "Bilan retraite",
        subTitle: "pour " + context.state.Civilite + " " + context.state.Nom,
      },
      {
        label: "Dossier",
        icon: <FaHome id="DossierAuditRetraitePage" />,
        content: <DossierPage />,
      },
      {
        label: "Carrière",
        icon: <FaSun id="carriere" />,
        content: <CarrierePage ClientConjoint="" />,
      },
      // {
      //   label: "Résultat " + context.state.Prenom,
      //   icon: <FaTable id="resultatRetraite" />,
      //   content: <ResultatPageRetraite ClientConjoint="" />,
      // },
      {
        label: "Simulations",
        icon: <FaCog />,
        content: <SimulationRetraite ClientConjoint="" />,
      },
       {
          isStudyManagement: true,
          content: <StudyManagement onSave={handleSave} onQuitToAudits={handleGoToAudits} onQuitToExtranet={handleGoToExtranet} />,
        },
    ];
    if (context.state.InclureConjoint === true) {
      pages = [
        {
          isTitle: true,
          title: "Bilan retraite",
          subTitle: "pour " + context.state.Civilite + " " + context.state.Nom,
        },
        {
          label: "Dossier",
          icon: <FaHome id="DossierAuditRetraitePage" />,
          content: <DossierPage />,
        },
        {
          label: "Carrière",
          icon: <FaSun id="carriere" />,
          content: <CarrierePage ClientConjoint="" />,
        },
        // {
        //   label: "Résultat " + context.state.Prenom,
        //   icon: <FaTable id="resultatRetraite" />,
        //   content: <ResultatPageRetraite ClientConjoint="" />,
        // },
        {
          label: "Simulations",
          icon: <FaCog />,
          content: <SimulationRetraite ClientConjoint="" />,
        },
        {
          isTitle: true,
          title: "Bilan retraite",
          subTitle: "pour " + context.state.CiviliteConjoint + " " + context.state.NomConjoint,
        },
        {
          label: "Carrière",
          icon: <FaSun id="carriereConjoint" />,
          content: <CarrierePage ClientConjoint="Conjoint" />,
        },
        // {
        //   label: "Résultat " + context.state.PrenomConjoint,
        //   icon: <FaTable />,
        //   content: <ResultatPageRetraite ClientConjoint="Conjoint" />,
        // },
        {
          label: "Simulations ",
          icon: <FaCog />,
          content: <SimulationRetraite ClientConjoint="Conjoint" />,
        },
        {
          isStudyManagement: true,
          content: <StudyManagement onSave={handleSave} onQuitToAudits={handleGoToAudits} onQuitToExtranet={handleGoToExtranet} />,
        },
      ];
    }

    if (context.state.ApiUser === true) {
      pages = pages.filter((k) => k.label !== "Dossier");
    }

    return pages;
  };

  return (
    <Pager
      withMenu
      pages={handlePages()}
      page={currentPage}
      onPageChange={(page) => {
        setCurrentPage(page);
      }}
      // navButtons={{
      //     'cancel' : { onClick: (evt) => { console.log('Cancel click')} },
      //     'previous' : { onClick: (evt) => { console.log('Previous click')} },
      //     'next' : { onClick: (evt) => { console.log('Next click')} },
      //     'validate' : { onClick: (evt) => { console.log('Validate click')} }
      // }}
      // customButtons={
      //     <Row fill>
      //         <Button onClick={(evt) => { console.log('Bouton supp click')}}>
      //             <FaCogs/>
      //             <span>Bouton supplémentaire</span>
      //         </Button>
      //     </Row>
      // }
    />
  );
};

export default AuditRetraitePage;
